import DeleteSvg from '@/shared/assets/images/Trash.svg'
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import { IInvitation } from "@/shared/api/invitations"
import { useUpdateInvitationModal } from "@/features/update-invitation"

interface DeleteInvitationProps {
    invitation: IInvitation
    onDelete: () => void
}

export const DeleteInvitation: FC<DeleteInvitationProps> = ({ invitation, onDelete }) => {
    const { openDeleteInvitationModal } = useUpdateInvitationModal()

    return (
        <DropdownItem 
            onClick={() => openDeleteInvitationModal(invitation, onDelete)}
            icon={DeleteSvg} 
            label={"Удалить"}        
        />
    )
}